export enum ValidationMessage {
  Required = 'Required',
  Phone = 'Must be a valid phone number',
  DateOfBirth = 'Driver must be older than 14 years old',
  Email = 'Must be a valid email',
}
